import SearchParamsBase from '../../../../Elements/SearchParamsBase';

export default class TpClientInvoiceLineItemAndJobLineSearchParams extends SearchParamsBase {
  static saveType = 'TpClientInvoiceLineItemAndJobLineSearchParams';
  initialize() {
    this.TpClientInvoiceId = '';
    this.Type = '';
  }

}
